import * as React from 'react';

import {Typography} from "@mui/material";

import './hoa-loading.scss';

interface ILoadingProps {
	loadingProgress: number;
	loadingMessage: string;
}

export default class Loading extends React.Component<ILoadingProps, {}> {
	private readonly STROKE_OFFSET = 266;

	public render() {
		const props = this.props;
		const loadingProgress = props.loadingProgress;
		const loadingMessage = props.loadingMessage;

		return ([
			<div key='loading-bar-container' className='loadingBarContainer'>

				<svg height='100' width='100' className='centerElement'>
					<circle
						cx='50'
						cy='50'
						r='47'
						stroke='white'
						strokeWidth='5'
						fill='transparent'
						strokeDasharray='570'
						strokeDashoffset='0'
					/>
					<circle
						cx='50'
						cy='50'
						r='42'
						stroke='red'
						strokeWidth='5'
						fill='transparent'
						strokeDasharray='266'
						strokeDashoffset={this.STROKE_OFFSET - (loadingProgress * (this.STROKE_OFFSET / 100))}
						transform='rotate(-90 50 50)'
					/>
				</svg>

				<img src='images/overview-hires.png' className='loadingIcon'/>

				<Typography variant='h6' className='loadingBarText'>
					{loadingMessage}
				</Typography>
			</div>,
		]);
	}
}
